const isProd = process.env.REACT_APP_ENV === 'production';

export const frontendURL = isProd
  ? process.env.REACT_APP_FRONTEND_URL_PRODUCTION
  : process.env.REACT_APP_FRONTEND_URL_TEST;

// Hostname the platform itself is served from. Anything else reaching this
// bundle is a brand's own domain, where the dashboard must not render — see
// `isPlatformHost`.
export const platformHost = (() => {
  try {
    return new URL(frontendURL || 'https://techproone.com').hostname;
  } catch (_) {
    return 'techproone.com';
  }
})();

/**
 * Is the page currently being served from the platform's own hostname?
 *
 * The same SPA bundle is served for every host — nginx `try_files` sends all
 * of them to one index.html — so without this check `/dashboard/*` renders on
 * every brand's custom domain too. The admin surface belongs on the platform
 * host only: a brand domain is customer-controlled and shares an origin with
 * the storefront, where brand-authored page content lives.
 *
 * localhost is treated as the platform host so local development is unchanged.
 */
export const isPlatformHost = () => {
  if (typeof window === 'undefined') return true;
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return host === platformHost || host.endsWith(`.${platformHost}`);
};

/**
 * API base. Relative in production, on purpose.
 *
 * It used to be the absolute `https://techproone.com/api/v1`. That works from
 * the platform's own host and breaks every brand domain: the backend resolves
 * a brand from the Host header, so a page served at www.acme.com calling
 * techproone.com/api asks "which brand is techproone.com?", gets none, and
 * renders the platform landing page instead of the brand's site.
 *
 * nginx proxies /api/ on every host, so a relative base keeps each call on
 * whatever domain the visitor is actually on — which is the whole basis of
 * host-based routing. It also makes every request same-origin, so cookies and
 * CORS stop being a consideration.
 *
 * A configured absolute base is honoured ONLY on the platform host. On a brand
 * domain it is ignored outright, because there is no value it could hold that
 * would be correct there — it would always point at some other origin and
 * always resolve the wrong brand. This is deliberately not a warning: a stale
 * REACT_APP_BACKEND_URL_PRODUCTION left in a deployed .env is exactly how
 * brand domains broke before, and a build-time env var is invisible at the
 * point where the damage shows up.
 */
const configuredProdBase = process.env.REACT_APP_BACKEND_URL_PRODUCTION || '';

export const backendURL = isProd
  ? ((configuredProdBase && isPlatformHost()) ? configuredProdBase : '/api/v1')
  : process.env.REACT_APP_BACKEND_URL_TEST;

export const platformName = process.env.REACT_APP_PLATFORM_NAME || 'TechProOne';
export const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@techproone.com';

export const defaultChainId = Number(process.env.REACT_APP_DEFAULT_CHAIN_ID || 11155111);
export const rpcURL         = process.env.REACT_APP_RPC_URL || '';

// What we tell brand owners to point their CNAME at. Settable per
// deployment; falls back to the canonical name on techproone.com so
// existing installs keep working.
export const brandCnameTarget = process.env.REACT_APP_BRAND_CNAME_TARGET || 'cdn.techproone.com';
